import React from 'react';
import { ArrowDownWideNarrow, ArrowUpWideNarrow } from 'lucide-react';
import { DisciplineEnum } from '../../../generated/graphql';

type GovernanceFilterBarProps = {
    discipline: DisciplineEnum | null;
    onDisciplineChange: (value: DisciplineEnum | null) => void;
    isAscending: boolean;
    onSortChange: (isAscending: boolean) => void;
};

const GovernanceFilterBar = ({ isAscending, onSortChange }: GovernanceFilterBarProps) => {
    return (
        <div className="flex items-center gap-2" data-testid="GovernanceFilterBar">
            <button
                type="button"
                className="btn-secondary text-sm"
                onClick={() => onSortChange(!isAscending)}
                title={isAscending ? 'Oldest first' : 'Newest first'}
            >
                {isAscending ? <ArrowUpWideNarrow size={14} /> : <ArrowDownWideNarrow size={14} />}
                {isAscending ? 'Oldest first' : 'Newest first'}
            </button>
        </div>
    );
};

export default GovernanceFilterBar;
